import Vue from 'vue'
import {
  Slider,
  Input,
  Row,
  Col,
  Form,
  FormItem,
  Button,
  Link,
  Pagination,
  Radio,
  Select,
  Option,
  Checkbox,
  Dialog,
  Tag,
  Message
} from 'element-ui'
import './theme/reset.css'

Vue.component(Slider.name, Slider)
Vue.component(Input.name, Input)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Button.name, Button)
Vue.component(Link.name, Link)
Vue.component(Pagination.name, Pagination)
Vue.component(Radio.name, Radio)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Dialog.name, Dialog)
Vue.component(Tag.name, Tag)

Vue.prototype.$message = Message
